import React from "react";
import PropTypes from "prop-types";

//
import Moment from "react-moment";
import { useTable, useSortBy } from "react-table";

//
import ReactTable from "../../../general/ReactTable";

//
import User from "../../../../assets/img/user.png";

function DesktopInvitationList({ items }) {
  // begin::table
  const data = items;

  const columns = React.useMemo(
    () => [
      {
        Header: "Email",
        accessor: "email", // accessor is the "key" in the data
        Cell: (cellProps) => {
          let value = cellProps.value;

          return (
            <div className="d-flex">
              <img src={User} alt="user" className="rounded-full"/>
              <small className="text-black fw-bolder">{value}</small>
            </div>
          );
        },
      },
      {
        Header: "date signed up",
        accessor: "created_at", // accessor is the "key" in the data,
        Cell: (cellProps) => {
          let value = cellProps.value;
          return (
            <small>
              <span className="fw-extra-bolder text-black">
                <Moment utc format="MMM DD, YYYY, ">{value}</Moment>
              </span>
              <span>
                <Moment utc format="hh:mm">{value}</Moment>
              </span>
            </small>
          );
        },
      },
    ],
    []
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data }, useSortBy);
  // end::table

  return (
    <div>
      <ReactTable
        rows={rows}
        sort
        sticky
        prepareRow={prepareRow}
        headerGroups={headerGroups}
        getTableProps={getTableProps}
        getTableBodyProps={getTableBodyProps}
      />

      <div className="space"></div>
    </div>
  );
}

DesktopInvitationList.propTypes = {
  items: PropTypes.array.isRequired,
};

export default DesktopInvitationList;
